import { render, staticRenderFns } from "./FullPageProduct.vue?vue&type=template&id=4613e82d"
import script from "./FullPageProduct.vue?vue&type=script&lang=ts"
export * from "./FullPageProduct.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports